import { EditOutlined } from '@ant-design/icons';
import { Card, Timeline, Typography } from 'antd';
import moment from 'moment';
import { Trans, useTranslation } from 'react-i18next';

import styles from './RequestJobPostingHistory.module.css';

interface RequestJobPostingEditTimelineTimelineProps {
  userName: string;
  changedFields: Record<string, string | number>;
  createdDate: string;
}

const RequestJobPostingEditTimeline = ({
  userName,
  changedFields,
  createdDate,
}: RequestJobPostingEditTimelineTimelineProps) => {
  const { t } = useTranslation();

  const orderedFields = [
    'type',
    'employee_name_being_replaced',
    'positions',
    'name',
    'start_salary',
    'end_salary',
    'branch',
    'company',
    'affiliate',
    'unit_business',
    'job_role',
    'department',
  ];

  const changedFieldsName = {
    type: t('Tipo de requisição'),
    name: t('Nome da requisição'),
    employee_name_being_replaced: t('Nome do substituído'),
    positions: t('Posições'),
    start_salary: t('Início da faixa salarial'),
    end_salary: t('Fim da faixa salarial'),
    branch: t('Unidade'),
    company: t('Empresa'),
    job_role: t('Cargo'),
    department: t('Departamento'),
    affiliate: t('Afiliada'),
    unit_business: t('Unidade de negócio'),
  };

  const requestTypeDict = {
    STAFF_INCREASE: t('Aumento de Quadro'),
    SUBSTITUTION: t('Substituição'),
  };

  return (
    <Timeline.Item dot={<EditOutlined className={styles.editedColor} />}>
      <Card>
        <Typography.Paragraph>
          <Typography.Text type="secondary">{moment(createdDate).format('LLL')}</Typography.Text>
          <br />
          <Typography.Text>
            <Typography.Text strong>{userName} </Typography.Text>
            <Trans>editou a requisição</Trans>
          </Typography.Text>
          <br />
          {orderedFields.map((field) => {
            if (field in changedFields) {
              const adjustedValue =
                field === 'type'
                  ? requestTypeDict[changedFields[field] as 'STAFF_INCREASE' | 'SUBSTITUTION']
                  : changedFields[field];

              return (
                <>
                  <br />
                  {
                    changedFieldsName[
                      field as
                        | 'type'
                        | 'name'
                        | 'employee_name_being_replaced'
                        | 'positions'
                        | 'start_salary'
                        | 'end_salary'
                        | 'branch'
                        | 'company'
                        | 'job_role'
                        | 'department'
                        | 'affiliate'
                        | 'unit_business'
                    ]
                  }
                  : {adjustedValue}
                </>
              );
            }
          })}
        </Typography.Paragraph>
      </Card>
    </Timeline.Item>
  );
};

export default RequestJobPostingEditTimeline;
